import { toThresholdValue } from 'modules/settings/components/custom-notifications/custom-notification-threshold.mapper';
import {
    ComparableCustomAlarmFormState,
    CreateCustomAlarmDefinitionInput,
    CustomAlarmFormState,
    UpdateCustomAlarmDefinitionInput,
} from 'modules/settings/pods/settings-devices/settings-devices-configuration/settings-devices-custom-alarm-form/settings-devices-custom-alarm-form.model';
import { CustomAlarmDefinitionTrackableEvent } from 'modules/settings/pods/settings-devices/settings-devices-configuration/domain/custom-alarm-definition.vm';

export const mapComparableFormState = (form: CustomAlarmFormState): ComparableCustomAlarmFormState => ({
    name: form.name,
    selectedEventIds: form.selectedEventIds,
    windowDays: form.windowDays,
    notifications: form.notifications,
    isResettable: form.isResettable,
    requiresCommentOnReset: form.requiresCommentOnReset,
});

export const buildCreatePayload = (
    form: CustomAlarmFormState,
    selectedEvents: CustomAlarmDefinitionTrackableEvent[],
    deviceTypeId: string
): CreateCustomAlarmDefinitionInput => ({
    definedFromDomainType: 'DEVICE_TYPE',
    applicableToDomainType: 'DEVICE',
    domainEntityId: deviceTypeId,
    name: form.name.trim(),
    eventsToTrack: selectedEvents,
    trackingTypeConfiguration: {
        type: 'SLIDING_WINDOW',
        windowDays: Number(form.windowDays),
    },
    grayNotification: toThresholdValue(form.notifications.gray),
    yellowNotification: toThresholdValue(form.notifications.yellow),
    redNotification: toThresholdValue(form.notifications.red),
    isResettable: form.isResettable,
    requiresCommentOnReset: form.requiresCommentOnReset,
});

export const buildUpdatePayload = (
    form: CustomAlarmFormState,
    selectedEvents: CustomAlarmDefinitionTrackableEvent[],
    deviceTypeId: string
): UpdateCustomAlarmDefinitionInput => ({
    definedFromDomainType: 'DEVICE_TYPE',
    applicableToDomainType: 'DEVICE',
    domainEntityId: deviceTypeId,
    eventsToTrack: selectedEvents,
    name: form.name.trim(),
    trackingTypeConfiguration: {
        type: 'SLIDING_WINDOW',
        windowDays: Number(form.windowDays),
    },
    grayNotification: toThresholdValue(form.notifications.gray),
    yellowNotification: toThresholdValue(form.notifications.yellow),
    redNotification: toThresholdValue(form.notifications.red),
    isResettable: form.isResettable,
    requiresCommentOnReset: form.requiresCommentOnReset,
});
